import type { FuelType } from './report.types'

export type CostCategory = 'advance' | 'paidRoads' | 'fuel';

export const COST_CATEGORIES: CostCategory[] = ['advance', 'paidRoads', 'fuel']

export interface VehicleCostEntry {
  id: string;
  date: string;
  category: CostCategory;
  amountPLN: number;
  country?: string;
  label: string;
  liters?: number;
  fuelType?: FuelType;
  reportId: string;
  reportNumber: string;
  driverId: string;
  driverName?: string;
}

export interface VehicleAnalyticsTotals extends Record<CostCategory, number> {
  all: number;
  fuelLiters: number;
}
